import { ReactNode } from 'react';
import { cn } from '@anytag/shared-utils';
import {
  DrawerRoot,
  DrawerClose,
  DrawerHeader,
  DrawerTitle,
  DrawerContent,
  type DrawerDialogProps,
  type DrawerContentProps
} from '../shadcn-blocks/drawer';
import { Icon } from '../Icon';

export type DrawerProps = DrawerDialogProps &
  Pick<DrawerContentProps, 'onInteractOutside' | 'className'> & {
    title?: ReactNode;
    onClose?: () => void;
    hasCloseButton?: boolean;
  };

export const Drawer = ({
  title,
  onClose,
  hasCloseButton = true,
  children,
  className,
  onInteractOutside,
  ...restProps
}: DrawerProps) => (
  <DrawerRoot direction="right" {...restProps}>
    <DrawerContent onInteractOutside={onInteractOutside} className={cn('w-200', className)}>
      {title ? (
        <DrawerHeader className="justify-between border-b-border">
          <DrawerTitle>{title}</DrawerTitle>

          {hasCloseButton ? (
            <DrawerClose>
              <Icon
                className="cursor-pointer hover:icon-color-black"
                icon="close"
                size={12}
                variant="light-gray"
                onClick={onClose}
              />
            </DrawerClose>
          ) : null}
        </DrawerHeader>
      ) : null}

      <div className="overflow-y-auto">{children}</div>
    </DrawerContent>
  </DrawerRoot>
);
